export function isOutofStock(
  // companyNumber,
  webOrderable,
  //   webFlags,
  webVisible,
  nab,
  ddrFlag
) {
  return (
    // will modify the logic
    // (companyNumber == "0831" || companyNumber == "1286") &&
    nab === 0 &&
    ~~ddrFlag === 0 &&
    // webFlags == true &&
    webVisible === true &&
    webOrderable === true
  );
}
